import React from 'react';

type SafeImgProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  fallback: string;
};

export const SafeImg = ({ src, fallback, alt = '', ...rest }: SafeImgProps) => {
  const [url, setUrl] = React.useState(src);
  const triedFallback = React.useRef(false);

  return (
    <img
      src={url}
      alt={alt}
      onError={() => {
        if (!triedFallback.current) {
          triedFallback.current = true;
          setUrl(fallback);
        }
      }}
      {...rest}
    />
  );
};
